import { EntityTemplateVariables, TemplateVariable } from '@tools/interfaces/template';

export const getAccessControlBadgeFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.access_control_badge.badge_number.label',
      contentValue: `{{ ${entity}accessControlBadge.badge_number }}`,
      description: 'templates.access_control_badge.badge_number.description',
    },
    {
      label: 'templates.access_control_badge.code.label',
      contentValue: `{{ ${entity}accessControlBadge.code }}`,
      description: 'templates.access_control_badge.code.description',
    },
    {
      label: 'templates.access_control_badge.status.label',
      contentValue: `{{ ${entity}accessControlBadge.status }}`,
      description: 'templates.access_control_badge.status.description',
    },
    {
      label: 'templates.access_control_badge.type.label',
      contentValue: `{{ ${entity}accessControlBadge.type }}`,
      description: 'templates.access_control_badge.type.description',
    },
  ];
};

export const templateAccessControlBadge: EntityTemplateVariables = {
  fields: getAccessControlBadgeFieldsForEntity(''),
  related: [],
  relatedInLoop: [],
};
